import { jsxs, jsx } from 'react/jsx-runtime';
import { useContextAccessToken } from '../../permission/contexts/AnonShareTokenContext.js';
import AvatarUser from '../../user/components/AvatarUser/AvatarUser.js';
import { useWoody } from '../../woody/woody.js';
import { useInputControls } from '@fabric-app/hooks/useInputControls';
import { IconDropdown14Person } from '@fabric-app/icons/svg';
import { Flex } from '@fabric-app/ui/components/Flex';
import { MultiSelect } from '@fabric-app/ui/components/MultiSelect/MultiSelect';
import { cssTextEllipsis } from '@fabric-app/ui/constants/styled-utils';
import { useResponsive } from '@fabric-app/ui/hooks/useResponsive';
import { useQuery } from '@tanstack/react-query';
import { useMemo, useCallback } from 'react';
import { styled } from 'styled-components';

const defaultValue = [];
const MultiselectResourceCreators = ({ value = defaultValue, onChange, parentResourceId }) => {
  const { client } = useWoody();
  const accessToken = useContextAccessToken();
  const { data: creators, isLoading } = useQuery({
    queryKey: [
      "resource-creators"
    ],
    queryFn: () => {
      return client.v2("/v2/creators", {
        query: {
          accessToken,
          parentResourceId
        }
      });
    }
  });
  const { isMobileView } = useResponsive();
  const options = useMemo(() => {
    const res = (creators || [])?.map((creator) => {
      const name = creator.name || "Unknown";
      return {
        value: creator.id,
        label: /* @__PURE__ */ jsxs(Flex, {
          alignItems: "center",
          gap: isMobileView ? "elementsContainer" : "element",
          overflow: "hidden",
          children: [
            /* @__PURE__ */ jsx(AvatarUser, {
              user: creator,
              size: isMobileView ? 24 : 16
            }),
            /* @__PURE__ */ jsx(CreatorName, {
              children: name
            })
          ]
        }),
        stringLabel: creator.name || "Unknown"
      };
    }) || [];
    res.unshift({
      value: "placeholder",
      label: "Any creator",
      stringLabel: "Any creator"
    });
    return res;
  }, [
    creators,
    isMobileView
  ]);
  const searchInputControls = useInputControls();
  const filterDisplayedOption = useCallback((option) => {
    return option.stringLabel.toLowerCase().includes(searchInputControls.sanitizedValue.toLowerCase());
  }, [
    searchInputControls.sanitizedValue
  ]);
  const valueExistingOnly = useMemo(() => {
    return value.filter((v) => !!options.find((o) => o.value === v));
  }, [
    value,
    options
  ]);
  return /* @__PURE__ */ jsx(MultiSelect, {
    title: "Filter by person...",
    trigger: {
      icon: /* @__PURE__ */ jsx(IconDropdown14Person, {})
    },
    searchProps: {
      value: searchInputControls.value,
      onChange: searchInputControls.onChange,
      placeholder: isMobileView ? "Search for a person" : "Type a user name"
    },
    filterDisplayedOption,
    isLoading,
    options,
    value: valueExistingOnly,
    onValueChange: onChange,
    displayDivider: null
  });
};
const CreatorName = styled.span.withConfig({
  displayName: "MutliselectResourceCreators__CreatorName",
  componentId: "sc-af6ab727-0"
})([
  ``,
  ``
], cssTextEllipsis);

export { MultiselectResourceCreators };
//# sourceMappingURL=MutliselectResourceCreators.js.map
